module.exports = __webpack_public_path__ + "static/media/greenReportActive.00b84928.svg";